/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-key */
import React, { useState } from 'react';
import { Button, Form, message, Spin } from 'antd-v5';
import { connect } from 'react-redux';
import { useQuery } from 'react-query';
import StandardLayoutV2 from '../../../../Layout/StandardLayoutV2';
import { getMessageSettings, saveMessageSettings } from '../../../../../core/apiRequests';
import {
  bodyFormatter,
  messageDispatcher,
  getDefaultWelcomeMessage,
} from '../../../../../components/Routes/Configuration/MessageSettings/largeMsgSettingFns';
import useActionTextAreaFiles, {
  actionTextAreaFileActions,
} from '../../../../../components/Layout/TextAreaWithActions/useActionTextAreaFiles';
import yn from 'yn';
import { MessagingSettings } from './components/messaging';

const MessageSettings = ({ merchantId, stores, brandName }) => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);
  const [fileData, fileDispatch] = useActionTextAreaFiles();
  const [autoAsA2p, setAutoAsA2p] = useState(false);

  const { isFetching, refetch } = useQuery(
    ['messagingSettings', merchantId],
    async () => {
      const response = await getMessageSettings('merchant', merchantId);
      if (response) {
        messageDispatcher(response);
        fileDispatch({
          type: actionTextAreaFileActions.setImages,
          payload: { urls: response?.REVIEW_IMAGES_URL, files: [] },
        });
        const autoAsA2pValue = yn(response?.AUTO_AS_A2P) || false;
        setAutoAsA2p(autoAsA2pValue);
        const data = {
          defaultStore: response?.DEFAULT_STORE ? parseInt(response?.DEFAULT_STORE, 10) : undefined,
          setSchTime: response?.AUTO_MSG_TIME || undefined,
          autoCloseTime: response?.AUTO_CLOSE_MIN_DAYS ? parseInt(response?.AUTO_CLOSE_MIN_DAYS, 10) : 90,
          reviewMessage: response?.REVIEW_MESSAGE || '',
          sendWelcomeMessage: yn(response?.SEND_WELCOME_MESSAGE) || false,
          welcomeMessage: response?.WELCOME_MESSAGE || getDefaultWelcomeMessage(response?.brandName || brandName || ''),
          declutteredInbox: yn(response?.DECLUTTERED_INBOX) || false,
          allStoreConversationHistory: yn(response?.ALL_STORE_CONVERSATION_HISTORY) || false,
        };
        form.setFieldsValue(data);
      }
    },
    {
      enabled: !!merchantId,
      refetchOnWindowFocus: false,
    },
  );

  const handleSave = async () => {
    setSaving(true);
    try {
      const values = await form.validateFields();
      // When the toggle is OFF the welcome message Form.Item is unmounted,
      // so validateFields() won't include it. Preserve the stored value.
      if (values.welcomeMessage === undefined) {
        values.welcomeMessage = form.getFieldValue('welcomeMessage');
      }
      if (values.sendWelcomeMessage && (!values.welcomeMessage || !values.welcomeMessage.trim())) {
        message.warning('Please enter a welcome message.');
        setSaving(false);
        return;
      }
      const body = bodyFormatter({
        ...values,
        autoAsA2p,
        brandName,
        reviewImages: fileData,
        merchantConfig: {
          DECLUTTERED_INBOX: values.declutteredInbox,
        },
      });
      await saveMessageSettings('merchant', merchantId, body, 'messageConfig');
      refetch();
      message.success('Message settings saved successfully');
    } catch (error) {
      console.error('Failed to save settings:', error);
      if (error.errorFields && error.errorFields.length > 0) {
        error.errorFields.forEach(err => {
          message.error(err.errors[0]);
        });
      } else {
        message.error('Failed to save Message settings');
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <StandardLayoutV2
      title="Message Settings"
      description="Configure your message preferences below"
      classProps="flex-col-left"
      maxWidth="650px"
      styleProps={{ justifyContent: 'flex-start' }}
      containerStyles={{ backgroundColor: 'transparent', paddingRight: '32px', maxWidth: '650px' }}
      actions={
        <Button type="primary" onClick={handleSave} loading={saving} disabled={isFetching}>
          Save
        </Button>
      }
    >
      <Spin spinning={isFetching}>
        <Form form={form} layout="vertical" className="w-100-P" disabled={isFetching || saving}>
          <MessagingSettings form={form} stores={stores} fileData={fileData} fileDispatch={fileDispatch} />
        </Form>
      </Spin>
    </StandardLayoutV2>
  );
};

const mapStateToProps = state => ({
  merchantId: state.auth.merchantId,
  stores: state.auth.stores,
  brandName: state.auth.brandName,
});
export default connect(mapStateToProps, {})(MessageSettings);
